import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from 'src/widgets/widgets.module';
import { FormsModule } from '@angular/forms';

import { PlansAndFeaturesRoutingModule } from './plans-and-features-routing.module';
import { NewPlanShopComponent } from './new-plan-shop/new-plan-shop.component';
import { PlansAndFeaturesComponent } from './plans-and-features.component';
import { PlansLayoutAComponent } from './plans-layout-a/plans-layout-a.component';
import { PlansCardsListComponent } from './plans-cards-list/plans-cards-list.component';
import { SwiperModule } from 'swiper/angular';
import { ChangePlanShopComponent } from './change-plan-shop/change-plan-shop.component';
import { ChangePlanSummaryComponent } from './change-plan-summary/change-plan-summary.component';
import { PlanDetailsListComponent } from './plan-details-list/plan-details-list.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PlanBroadbandFactsComponent } from '@ztarmobile/zwp-widgets';

@NgModule({
  declarations: [NewPlanShopComponent, PlansAndFeaturesComponent, PlansLayoutAComponent,
    PlansCardsListComponent, ChangePlanShopComponent, ChangePlanSummaryComponent, PlanDetailsListComponent],
  imports: [
    CommonModule,
    FormsModule,
    WidgetsModule,
    SwiperModule,
    PlansAndFeaturesRoutingModule,
    MatAutocompleteModule,
    PlanBroadbandFactsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PlansAndFeaturesModule { }
